/**
 * @description Should be relative, since it is used in cdn-link,
 * which is imported inside vite.config.ts where aliases can't be used
 */
import type { URLString } from '../types';

export function withoutDuplicatedSlash(url: URLString) {
  return url.replace(/:(\/\/+)|\/\/+/g, function (_, afterProtocol) {
    return afterProtocol ? `:${afterProtocol}` : '/';
  });
}
